// Shared Claude API caller. In production, calls our /api/claude proxy
// (server holds the key). In dev, calls api.anthropic.com directly using
// VITE_ANTHROPIC_API_KEY so we don't need to run `vercel dev`.
//
// import.meta.env.DEV is replaced at build time by Vite — the dev branch
// (and the VITE_ANTHROPIC_API_KEY reference inside it) is stripped from
// production bundles, so the key never reaches a real visitor.

const PROD_ENDPOINT = "/api/claude";
const DIRECT_ENDPOINT = "https://api.anthropic.com/v1/messages";

const directHeaders = () => {
  const apiKey = import.meta.env.VITE_ANTHROPIC_API_KEY;
  if (!apiKey) {
    throw new Error("VITE_ANTHROPIC_API_KEY is not set. Add it to your .env file for local dev.");
  }
  return {
    "Content-Type": "application/json",
    "x-api-key": apiKey,
    "anthropic-version": "2023-06-01",
    "anthropic-dangerous-direct-browser-access": "true",
  };
};

export const callClaude = async ({ model, system, messages, max_tokens }) => {
  const useDirect = import.meta.env.DEV;
  const url = useDirect ? DIRECT_ENDPOINT : PROD_ENDPOINT;
  const headers = useDirect ? directHeaders() : { "Content-Type": "application/json" };

  const res = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify({ model, system, messages, max_tokens }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.error) {
    throw new Error(data?.error?.message || `Claude API error (${res.status}).`);
  }
  return data;
};
